import api from 'services/api';

export interface NotifyDateChangePayload {
	event_ids: string[];
	/** Optional free-text note from the organizer, shown at the top of the email. */
	custom_message?: string;
}

// Cross-event action: fans a date-change email out to every attendee of each event via pubsub.
// Takes an array of ids so the same call serves a future bulk-edit-of-events flow. The backend
// renders the email from the freshly-saved event dates and no-ops any event with zero attendees.
export const notifyAttendeesOfDateChange = (payload: NotifyDateChangePayload) =>
	api.post('/events/notify-date-change', payload);
